import { Component } from '@angular/core';
import { DynamicDialogComponent } from './dynamic-dialog.component';
import { DynamicDialog } from './dynamic-dialog';

@Component({
  imports: [DynamicDialogComponent],
  template: `
    <ct-dynamic-dialog title="Abweichende Forderungssummen">
      <p>
        Die eingegebene Gesamtsumme entspricht nicht der Summe der Einzelbeträge. Bist du sicher,
        dass die eingegebenen Daten korrekt sind?
      </p>
    </ct-dynamic-dialog>
  `,
})
export class DivergingSuggestedSumDialogComponent implements DynamicDialog<boolean> {}
